import { ContractType } from '@app/Models';

export class EnumHelpers {

    /**
     * Get all keys from enumeration.
     */
    public static keys(enumType: object): string[] {
        return Object.keys(enumType);
    }

    /**
     * Get key-value array from enumeration.
     */
    public static toKeyValueArray(enumType: object) {
        return EnumHelpers.keys(enumType)
        .map((key) => {
            return { key, text: key };
        });
    }

    public static contractTypeOptions() {
        const keys = Object.keys(ContractType).filter((key)=> key !== ContractType.None);
        return keys.map(key => {
            return { key: key, text: key };
        });
    }
}